import * as React from 'react';

import {Error404PageContainer} from './containers';

interface Props {}

export const Error404Page: React.FC<Props> = () => {
    return (
        <Error404PageContainer />
    );
};


